export default __webpack_public_path__ + "static/media/large-icon.0f574323.svg";